import React, { useState } from 'react';
import LegalChecklist from './LegelCheckList';
import Compliance from './Compliance';
import Goverment from './Goverment';
import Agreement from './Agreement';
import RealProperty from './RealProperty';

const Funding = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => setIsOpen(!isOpen);

  const options = ['Entrepreneur ', 'Individual', 'Community', 'Cooperative'];

  return (
    <div className='px-4 md:px-24 pt-4'>
      <div>
        <h1 className='font-bold text-[10px] md:text-[36px] text-[#03897B]'>PURPOSE</h1>
      </div>

      {/* Image Container */}
      <div className="relative w-full h-[100px] md:h-[427px] rounded-t-[5px] overflow-hidden mt-1">
        {/* Image */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746266362/image_66_ylhsrw.png"
          alt="Funding"
          className="w-full h-full object-cover"
        />

        {/* Logo */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014742/image_1717_1_mrc5cr.png"
          alt="Ad Luck Logo"
          className="absolute bottom-6 left-4 md:bottom-12 md:left-8 w-[60px] md:w-[174px]"
        />
      </div>

      {/* Bottom Bar */}
      <div className="w-full h-[30px] md:h-[78px] bg-[#e0e0e0] flex items-center justify-between px-4 md:px-6 font-bold text-sm rounded-b-[5px]">
        <span className='text-[10px] md:text-[24px]'>DUE DILIGENCE</span>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746014605/Expand_right_13_khjlok.png"
          alt="Arrow"
          className="h-[26px] w-[26px] md:h-[46px] md:w-[47px]"
        />
      </div>

      <div className='md:mt-4 md:mb-14 mt-5 mb-6'>
        <p className='md:text-[18px] text-[8px] font-normal'>
        Ad-Luck positions itself as a trusted intermediary for development partners, streamlining the disbursement of funds to ensure they reach targeted beneficiaries efficiently, transparently, and with measurable impact on community development. <br/>
        Entrepreneurs can access funding from development partners by registering through the Ad-Luck Holdings funding portal. Once registered, their applications are evaluated for compliance with funding criteria. Those who meet the requirements are then eligible to receive financial support.
        </p>
      </div>
   <div className='flex items-center md:space-x-6'>
   <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>DUE DILIGENCE</p>
      <div className="flex items-center ml-auto pr-3 md:pr-0 md:mb-1 relative">
        <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
        Entrepreneur 
        </p>

        {/* Toggle Button for Dropdown */}
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746113102/Expand_down_17_achr9o.png"
          alt="Expand"
          onClick={toggleDropdown}
          className="cursor-pointer w-[20px] h-[15px] md:h-[55px] md:w-[40px] object-contain bg-[#F38323] md:px-2 px-[2px] py-[1px] md:py-1 rounded-tr-md md:rounded-tr-[5px] rounded-br-md md:rounded-br-[5px] "
        />

        {/* Dropdown Menu */}
        {isOpen && (
          <div className="absolute top-full right-0 mt-1 flex justify-center items-center bg-white border border-gray-400 rounded shadow-md z-10 text-[10px] md:text-[18px] w-[120px] md:w-[220px] md:h-[300px]">
       <div>
       <h1 className='md:text-[20px] md:px-2 font-bold  md:mb-5' >DUE DILIGENCE </h1>

       {options.map((option, idx) => (
           <div>
           <p
                key={idx}
                className="px-2 py-2 hover:bg-gray-100 cursor-pointer"
              >
                {option}
              </p>
           </div>
            ))}
       </div>
          </div>
        )}
      </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Select due diligence</p>
    </div>
         
        <a href='/BusinessPlan'>
        <div>
      <p className='md:text-[20px] text-[8px]  font-bold md:mb-3'>BUSINESS PLANS</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Business plans
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to business plans</p>

            </div>
        </a>
       <a href='/CreditScore'>
       <div>
      <p className='md:text-[20px] text-[8px] font-bold md:mb-3'>CREDIT SCORE</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Credit score
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to credit score</p>

            </div>
       </a>
        <a href='/LocationApplication'>
        <div>
      <p className='md:text-[20px] text-[8px]   font-bold md:mb-3'>LOAN APPLICATION</p>
              <div className="flex items-center  ml-auto pr-3 md:pr-0 md:mb-1">
                <p className="md:text-[18px] text-[6px] bg-[#152C24] text-white px-2 md:px-4 md:w-[180px] md:h-[55px] md:py-[16px] py-[3px] md:rounded-tl-[5px] rounded-tl-md font-medium md:rounded-bl-[5px] rounded-bl-md text-center whitespace-nowrap">
                Loan Application
                </p>
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[5px] md:h-[55px] md:w-[40px] hidden md:flex object-contain md:rounded-tr-[5px] rounded-tr-md font-bold md:rounded-br-[5px] bg-[#F38323] px-2 md:py-1 "
                />
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745789598/Expand_right_10_biutz5.png"
                  alt="Expand"
                  className="w-[20px] h-[15px] md:hidden flex py-[1px] md:h-[423px] md:w-[57px] object-contain md:rounded-tr-xl rounded-tr-md font-bold md:rounded-br-xl rounded-br-md bg-[#F38323] md:px-2 px-[2px] md:py-1 transition-transform duration-300 hover:rotate-45"
                />
              </div>
      <p className='md:text-[16px] text-[5px] font-light md:mb-3 mt-1'>Go to funding</p>

            </div>
        </a>
   </div>
   <div className='md:mt-1 mb-6 mt-5 md:mb-14'>
   <h1 className='md:text-[24px] text-[10px] font-bold mb:mb-5'>DUE DILIGENCE</h1>
        <p className='md:text-[18px] text-[6px] font-normal md:mt-4'>
        Ad-Luck’s funding due diligence process is designed to ensure transparency, accountability, and alignment with development partners’ objectives. It includes a thorough assessment of each applicant’s legal compliance, financial health, business viability, and social impact potential. Applicants are vetted through background checks, document verification, and risk analysis before any funds are disbursed. Continuous monitoring and reporting mechanisms are also in place to track fund utilization and project outcomes.
        </p>
      </div>
      <LegalChecklist/>
      <div className='md:h-20 h-2'></div>
      <Compliance/>
      <Goverment/>
      <Agreement/>
      <RealProperty/>
      <div className="flex justify-end md:mt-3 mt-4">
        <button
          className="flex items-center md:gap-2 gap-2  hover:bg-[#0f1f1a] text-black hover:text-white  md:py-3 py-1 rounded-md text-[6px] md:text-lg font-normal italic transition"
        >
          Save
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745670022/Arhive_load_duotone_line_c6pcpp.png"
            alt="Save Icon"
            className="md:w-11 md:h-11 h-3 w-3"
          />
        </button>
      </div>
      {/* Register Button */}
      <button className="w-full bg-[#03897B] flex justify-center md:mt-3  border-b-[3px] md:py-2 py-1 border-[#FDBD26] text-center md:h-[74px] h-[20px] text-white md:text-[36px] text-[6px] font-bold rounded-md">
      Submit
      </button>
         {/* Buttons */}
         <div className="flex md:gap-4 gap-1  justify-end md:mt-7 mt-2 md:mb-10 mb-5">
        {/* Edit Button */}
        <div>
        <button className="flex items-center justify-between md:w-[230px] w-[100px] md:h-[61px] h-[20px] bg-[#03897B] text-white md:text-[14px] text-[6px] font-bold rounded-[10px] md:px-8 px-4 ">
          <span>EDIT</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690463/Edit_fill_llaa3q.png"
            alt="Edit Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px] text-[6px] md:mt-4  mt-1 font-normal md:px-1 '>
        Edit registration form
        </p>
        </div>


        {/* Save Button */}
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SAVE</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1745690487/Arhive_load_duotone_line_1_hbsukd.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Save registration 
        </p>
    </div>
    <div>
    <button className="flex items-center justify-between w-[100px] md:w-[230px] h-[20px] md:h-[61px] bg-[#03897B] text-white md:text-[14px]  text-[6px] font-bold  rounded-[10px] px-4">
          <span>SEND</span>
          <img
            src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746037449/Send_hor_fill_lfkysb.png"
            alt="Save Icon"
            className="md:w-[35px] h-2  md:h-[38px] w-2 "
          />
        </button>
        <p className='md:text-[14px]  text-[6px] md:mt-4 mt-1 font-normal md:px-1 '>
        Send Due diligence form
        </p>
    </div>
      </div>
    </div>
  );
};

export default Funding;
